import client from './client';

export const getRebates = (params) => client.get('/rebates', { params });

export const getRebateDetail = (id) => client.get(`/rebates/${id}`);
